import axios from 'axios'
import { UrlBase } from './config'

const listsPersons = {}

listsPersons.addSelectedUsersToList = async (token, companyId, appId, listId, usersIds) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        listId,
        usersIds
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/bulk/change/list/add`
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

listsPersons.addUsersToList = (token, { companyId, appId, listId, search, advancedSearch }) => {
  let likings = { ...advancedSearch.usersLikings }
  if (likings.and.length === 0 && likings.or.length === 0) {
    likings = null
  }

  let spotifyGenres = { ...advancedSearch.spotifyGenres }
  if (spotifyGenres.and.length === 0 && spotifyGenres.or.length === 0) {
    spotifyGenres = null
  }

  let spotifyArtists = { ...advancedSearch.spotifyArtists }
  if (spotifyArtists.and.length === 0 && spotifyArtists.or.length === 0) {
    spotifyArtists = null
  }

  let spotifyTracks = { ...advancedSearch.spotifyTracks }
  if (spotifyTracks.and.length === 0 && spotifyTracks.or.length === 0) {
    spotifyTracks = null
  }

  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId + '/import',
      data: {
        extradata: advancedSearch.extradata,
        filterResponsible: advancedSearch.filterResponsible,
        isImported: advancedSearch.isImported,
        journeyArray: advancedSearch.journeyArray,
        likings,
        rolIdArray: advancedSearch.roles,
        search: search,
        spotifyArtists,
        spotifyGenres,
        spotifyTracks,
        socialNetworks: advancedSearch.socialNetworks,
        verified: advancedSearch.verified
      }
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.createList = (token, { companyId, appId, listName, listType, importedFrom }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists',
      data: {
        name: listName,
        listType,
        importedFrom
      }
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.createEmptyList = async (token, companyId, appId, listName) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        name: listName
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/lists`
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

listsPersons.deleteSpecificList = (token, companyId, appId, listId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.deleteUserFromList = (token, companyId, appId, listId, userId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId + '/users/' + userId
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.getSpecificList = (token, companyId, appId, listId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.getUsersOfSpecificList = (token, companyId, appId, listId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId + '/users'
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

listsPersons.getListsPersons = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page || 1,
        sortBy: pagination.sortBy || '',
        descending: pagination.descending || '',
        limit: pagination.itemsPerPage || 50,
        search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists'
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      console.log(error)
    })
  })
}

listsPersons.importNew = (token, companyId, appId, { file, headers, listId, importType, responsibleId }) => {
  return new Promise((resolve, reject) => {
    const fd = new FormData()
    /* eslint-enable */
    fd.append('upload-files', file)
    fd.append('fileHeaders', JSON.stringify(headers))
    fd.append('listId', listId)
    if (responsibleId) fd.append('responsibleId', responsibleId)
    if (importType) fd.append('importType', importType)

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/import',
      data: fd
    }

    axios(request).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

// https://admin.keybe.bio/companies/:companyId/apps/:appKey/lists/:listId

listsPersons.updateSpecificList = (token, companyId, appId, listId, { name }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/lists/' + listId,
      data: {
        name: name
      }
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

export default listsPersons
